import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import {
  TextButtonDriver,
  textButtonDriverFactory,
} from '../TextButton/TextButton.driver';
import { DATA_HOOKS } from './constants';

export interface AvatarGroupDriver extends BaseUniDriver {
  getAvatarCount(): Promise<number>;
  getHiddenAvatarCountElementText(): Promise<string>;
  isHiddenAvatarGroupExists(): Promise<boolean>;
  textButton: TextButtonDriver;
}

export const avatarGroupDriverFactory = (
  base: UniDriver,
): AvatarGroupDriver => {
  const getAvatarCount = () =>
    base.$$(`[data-hook="${DATA_HOOKS.avatar}"]`).count();

  const getHiddenAvatarCountElementText = () =>
    base
      .$(`[data-hook="${DATA_HOOKS.hiddenAvatarCount}"]`)
      .attr('data-initials');

  const isHiddenAvatarGroupExists = async () =>
    base.$(`[data-hook="${DATA_HOOKS.hiddenAvatarCount}"]`).exists();

  const textButton = textButtonDriverFactory(
    base.$(`[data-hook="${DATA_HOOKS.textButton}"]`),
  );
  return {
    ...baseUniDriverFactory(base),
    getAvatarCount,
    textButton,
    getHiddenAvatarCountElementText,
    isHiddenAvatarGroupExists,
  };
};
